import React, { useState } from "react";
import { Button, Card, Col, Form, ProgressBar, Row } from "react-bootstrap";
import { CONTRACTOR_COPY } from "./Contractor-Insurance-Quote_Strings";

interface IFormState {
  businessName: string;
  years: string;
  employees: string;
  tradeType: string;
  coverage: {
    generalLiability: boolean;
    workersComp: boolean;
    commercialAuto: boolean;
  };
  contact: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
  };
}

export const Contractor_QuoteWizard_H2: React.FC = () => {
  const [step, setStep] = useState(1);
  const [form, setForm] = useState<IFormState>({
    businessName: "",
    years: "",
    employees: "",
    tradeType: "",
    coverage: {
      generalLiability: false,
      workersComp: false,
      commercialAuto: false,
    },
    contact: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
    },
  });

  const totalSteps = 3;

  const handleChange = (
    field: keyof IFormState | keyof IFormState["coverage"] | keyof IFormState["contact"],
    value: any
  ) => {
    if (step === 1 && typeof field === "string" && field in form) {
      setForm({ ...form, [field]: value });
    }
    if (step === 2 && field in form.coverage) {
      setForm({ ...form, coverage: { ...form.coverage, [field]: value } });
    }
    if (step === 3 && field in form.contact) {
      setForm({ ...form, contact: { ...form.contact, [field]: value } });
    }
  };

  const next = () => setStep((s) => Math.min(totalSteps, s + 1));
  const back = () => setStep((s) => Math.max(1, s - 1));
  const submit = () => {
    console.log("Contractor form payload →", form);
    alert("Quote request submitted! Check console for payload.");
  };

  return (
    <Card className="p-4 shadow-sm">
      <Card.Body>
        <h2>{CONTRACTOR_COPY.header}</h2>
        <p>{CONTRACTOR_COPY.intro}</p>

        <ProgressBar
          now={(step / totalSteps) * 100}
          className="mb-4"
          label={`Step ${step} of ${totalSteps}`}
        />

        {step === 1 && (
          <>
            <h4>{CONTRACTOR_COPY.sections.business.title}</h4>
            <p>{CONTRACTOR_COPY.sections.business.help}</p>
            <Form.Group className="mb-3">
              <Form.Label>{CONTRACTOR_COPY.sections.business.fields.name}</Form.Label>
              <Form.Control
                value={form.businessName}
                onChange={(e) => handleChange("businessName", e.target.value)}
              />
            </Form.Group>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>{CONTRACTOR_COPY.sections.business.fields.years}</Form.Label>
                  <Form.Control
                    value={form.years}
                    onChange={(e) => handleChange("years", e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>{CONTRACTOR_COPY.sections.business.fields.employees}</Form.Label>
                  <Form.Control
                    value={form.employees}
                    onChange={(e) => handleChange("employees", e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3">
              <Form.Label>{CONTRACTOR_COPY.sections.business.fields.tradeType}</Form.Label>
              <Form.Control
                value={form.tradeType}
                onChange={(e) => handleChange("tradeType", e.target.value)}
              />
            </Form.Group>
          </>
        )}

        {step === 2 && (
          <>
            <h4>{CONTRACTOR_COPY.sections.coverage.title}</h4>
            <p>{CONTRACTOR_COPY.sections.coverage.help}</p>
            <Form.Check
              type="checkbox"
              id="generalLiability"
              label={CONTRACTOR_COPY.sections.coverage.fields.generalLiability}
              checked={form.coverage.generalLiability}
              onChange={(e) => handleChange("generalLiability", e.target.checked)}
            />
            <Form.Check
              type="checkbox"
              id="workersComp"
              label={CONTRACTOR_COPY.sections.coverage.fields.workersComp}
              checked={form.coverage.workersComp}
              onChange={(e) => handleChange("workersComp", e.target.checked)}
            />
            <Form.Check
              type="checkbox"
              id="commercialAuto"
              label={CONTRACTOR_COPY.sections.coverage.fields.commercialAuto}
              checked={form.coverage.commercialAuto}
              onChange={(e) => handleChange("commercialAuto", e.target.checked)}
            />
          </>
        )}

        {step === 3 && (
          <>
            <h4>{CONTRACTOR_COPY.sections.contact.title}</h4>
            <p>{CONTRACTOR_COPY.sections.contact.help}</p>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>{CONTRACTOR_COPY.sections.contact.fields.firstName}</Form.Label>
                  <Form.Control
                    value={form.contact.firstName}
                    onChange={(e) => handleChange("firstName", e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>{CONTRACTOR_COPY.sections.contact.fields.lastName}</Form.Label>
                  <Form.Control
                    value={form.contact.lastName}
                    onChange={(e) => handleChange("lastName", e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3">
              <Form.Label>{CONTRACTOR_COPY.sections.contact.fields.email}</Form.Label>
              <Form.Control
                type="email"
                value={form.contact.email}
                onChange={(e) => handleChange("email", e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>{CONTRACTOR_COPY.sections.contact.fields.phone}</Form.Label>
              <Form.Control
                value={form.contact.phone}
                onChange={(e) => handleChange("phone", e.target.value)}
              />
            </Form.Group>
          </>
        )}

        <div className="d-flex justify-content-between mt-4">
          {step > 1 && (
            <Button variant="secondary" onClick={back}>
              {CONTRACTOR_COPY.buttons.back}
            </Button>
          )}
          {step < totalSteps && (
            <Button variant="primary" onClick={next}>
              {CONTRACTOR_COPY.buttons.next}
            </Button>
          )}
          {step === totalSteps && (
            <Button variant="success" onClick={submit}>
              {CONTRACTOR_COPY.buttons.submit}
            </Button>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default Contractor_QuoteWizard_H2;
